<template>
	<div>
		<el-dialog :close-on-click-modal="false" title="" :visible.sync="IsShowPage" width="30%" center :show-close="false">
			<div class="content">
				<div class="title">
					<p class="blod">寄存寄售首选流转时光</p>
					<p>支持多种交易方式</p>
				</div>
				<div class="align-center flex">
					<div class="center-item">
						<img class="popup-icon" src="../../static/popup/popup-icon1.png" alt="" />
						<img class="code-icon" src="../../static/popup/code-icon1.png" alt="" />
						<p>微信小程序</p>
					</div>
					<div class="center-item">
						<img class="popup-icon" src="../../static/popup/popup-icon2.png" alt="" />
						<img class="code-icon" src="../../static/popup/code-icon2.png" alt="" />
						<p>支付宝小程序</p>
					</div>
					<div class="center-item">
						<img class="popup-icon" src="../../static/popup/popup-icon3.png" alt="" />
						<img class="code-icon" src="../../static/popup/new-code-icon3.png" alt="" />
						<p>联系客服</p>
					</div>
				</div>
				<div class="tip-t">您也可以在App Store 安卓各应用市场搜索“流转时光”</div>
				<div class="phone-number">
					<img src="../../static/popup/phone.png" alt="" />
					<span>130-3306-0125</span>
				</div>
				<img @click="closedFun" class="close-img" src="../../static/popup/close.png" alt="" />
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				IsShowPage: true,   
			}
		},
		methods: {
			closedFun() {
				this.$emit('close', false)
			}
		}
	}
</script>

<style scoped>
	.content {
		position: relative;
	}
	.title {
		font-size: 14px;
		color: #666;
		padding-bottom: 10px;
	}
	.blod {
		font-weight: 600;
		font-size: 20px;
		color: #333333;
	}
	.align-center {
		padding-top: 20px;
		border-top: 1px solid #FE3D3A;
		justify-content: space-around;
	}
	.center-item {
		font-weight: 600;
		font-size: 15px;
		color: #333333;
		text-align: center;
	}
	.popup-icon {
		display: block;
		width: 30px;
		height: 30px;
		margin: 0 auto;
	}
	.code-icon {
		display: block;
		width: 100px;
		height: 100px;
		margin: 0 auto;
		margin-top: 20px;
		margin-bottom: 20px;
	}
	.tip-t {
		font-weight: 500;
		font-size: 13px;
		color: #666;
		margin-top: 20px;
		margin-bottom: 20px;
		text-align: center;
	}
	.phone-number {
		width: 243px;
		height: 48px;
		line-height: 48px;
		background: #F8F8F8;
		border-radius: 24px;
		margin: 0 auto;
		font-weight: 600;
		font-size: 18px;
		color: #FE3D3A;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.phone-number img {
		margin-right: 3px;
	}
	.close-img {
		width: 12px;
		height: 12px;
		position: absolute;
		right: 0px;
		top: -29px;
		z-index: 99;
	}
</style>


// WEBPACK FOOTER //
// src/components/ConsultDialog.vue